import * as React from "react";
import PropTypes from "prop-types";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { format } from "date-fns";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import edit_pencil from "../../../assets/img/icons/edit_pencil.svg";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import exportIcon from "../../../assets/img/icons/exportIcon.svg";

import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import Export_Button from "../../../assets/img/icons/Export_Button.svg";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import { visuallyHidden } from "@mui/utils";
import SearchBar from "material-ui-search-bar";
import { Link, useHistory } from "react-router-dom";
import moment from "moment/moment";
import classNames from "classnames";
import useStyles from "../styles";

function createData(
  invoiceNo,
  TDW,
  customerName,
  serviceDescription,
  datePosted,
  dueDate,
  total,
  status,
) {
  return {
    invoiceNo,
    TDW,
    customerName,
    serviceDescription,
    datePosted,
    dueDate,
    total,
    status,
  };
}

const rows = [
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-521234587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-521224587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
  createData(
    "WO-5214587",
    "TDW-21458",
    "Decks and docks Lumber company",
    "Lorem ipsum dolor sit amet, consecetur adipiscing elit.",
    "12-16-2022",
    "12-29-2022",
    "$1,254,21",
    "Open",
  ),
];
/* istanbul ignore next */
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
//table sorting
/* istanbul ignore next */
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
/* istanbul ignore next */
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "internalId",
    numeric: false,
    disablePadding: false,
    label: "TDW Invoice No.",
  },
  {
    id: "customer",
    numeric: false,
    disablePadding: false,
    label: "Customer Name",
  },
  {
    id: "comment",
    numeric: false,
    disablePadding: false,
    label: "Comment",
  },

  {
    id: "dueDate",
    numeric: false,
    disablePadding: false,
    label: "Due Date",
  },
  {
    id: "amount",
    numeric: false,
    disablePadding: false,
    label: "Total",
  },
  {
    id: "aasmState",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "edit",
    numeric: false,
    disablePadding: false,
    label: "",
  },
  {
    id: "export",
    numeric: false,
    disablePadding: false,
    label: "",
  },
];
/* istanbul ignore next */
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default function OverallTable({
  invoicesData,
  search,
  dateRange,
  perPage,
}) {
  const classes = useStyles();
  const history = useHistory();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(perPage);
  const [searchValue, setSearchValue] = React.useState("");

  console.log(invoicesData, "invajbajcn");

  // Selectors from state
  /* istanbul ignore next */
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "desc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  //select all table row
  /* istanbul ignore next */
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  /* istanbul ignore next */
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };
  //handle Page change
  /* istanbul ignore next */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  //handle Row page change
  /* istanbul ignore next */
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  /* istanbul ignore next */
  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  /* istanbul ignore next */
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  // navigate to the detail page of given invoice id
  /* istanbul ignore next */
  const onInvoiceClick = (invoiceId) => {
    history.push({
      pathname: `/app/invoices/${invoiceId}`,
      state: { invoiceId: invoiceId },
    });
  };

  console.log(selected, "invoiceNo");
  /* istanbul ignore next */
  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer sx={{ padding: "32px" }}>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size={dense ? "small" : "medium"}
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {invoicesData &&
                invoicesData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .filter(
                    (searchData) =>
                      searchData?.customer?.name
                        .toLowerCase()
                        ?.includes(searchValue.toLowerCase()) ||
                      searchData?.invoiceNo
                        ?.toLowerCase()
                        ?.includes(searchValue.toLowerCase()) ||
                      searchData?.internalId
                        ?.toLowerCase()
                        ?.includes(searchValue.toLowerCase()),
                  )
                  .map((row, index) => {
                    const isItemSelected = isSelected(row);
                    const labelId = `enhanced-table-checkbox-${row}`;

                    return (
                      <TableRow
                        hover
                        onClick={(event) => handleClick(event, row)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row}
                        selected={isItemSelected}
                      >
                        <TableCell>
                          <div
                            className="cursor-pointer"
                            onClick={() => onInvoiceClick(row?.id)}
                          >
                            {row?.internalId}
                          </div>
                        </TableCell>
                        <TableCell>{row?.customer?.name}</TableCell>
                        <TableCell>{row?.comment ?? "N/A"}</TableCell>
                        <TableCell>
                          {row?.createdAt?.substring(0, 10)}
                        </TableCell>
                        <TableCell>
                          $ {(row?.amount + row?.tax)?.toFixed(2)}
                        </TableCell>
                        <TableCell>
                          {row?.aasmState == "open" && (
                            <span className={classes.aasmStateOpen}>
                              {row?.aasmState
                                ? row?.aasmState[0].toUpperCase() +
                                  row?.aasmState.slice(1)
                                : ""}
                            </span>
                          )}
                          {row?.aasmState == "disputed" && (
                            <span className={classes.aasmStateDisputed}>
                              {row?.aasmState
                                ? row?.aasmState[0].toUpperCase() +
                                  row?.aasmState.slice(1)
                                : ""}
                            </span>
                          )}
                          {row?.aasmState == "pending" && (
                            <span className={classes.aasmStateDisputed}>
                              {row?.aasmState
                                ? row?.aasmState[0].toUpperCase() +
                                  row?.aasmState.slice(1)
                                : ""}
                            </span>
                          )}
                          {row?.aasmState == "paid" && (
                            <span className={classes.aasmStatePaid}>
                              {row?.aasmState
                                ? row?.aasmState[0].toUpperCase() +
                                  row?.aasmState.slice(1)
                                : ""}
                            </span>
                          )}
                          {row?.aasmState == "closed" && (
                            <span className={classes.aasmStateClosed}>
                              {row?.aasmState
                                ? row?.aasmState[0].toUpperCase() +
                                  row?.aasmState.slice(1)
                                : ""}
                            </span>
                          )}
                          {row?.aasmState == "internal" && (
                            <span className={classes.aasmStateInternal}>
                              {row?.aasmState
                                ? row?.aasmState[0].toUpperCase() +
                                  row?.aasmState.slice(1)
                                : ""}
                            </span>
                          )}
                          {row?.aasmState == "invoiced" && (
                            <span className={classes.aasmStateInvoiced}>
                              {row?.aasmState
                                ? row?.aasmState[0].toUpperCase() +
                                  row?.aasmState.slice(1)
                                : ""}
                            </span>
                          )}
                        </TableCell>{" "}
                        <TableCell>
                          <div
                            className="cursor-pointer"
                            onClick={() => onInvoiceClick(row?.id)}
                          >
                            <img src={edit_pencil} />
                          </div>
                        </TableCell>
                        <TableCell>
                          <img className={"clickable-image"} src={exportIcon} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[25, 35, 50]}
          component="div"
          count={invoicesData?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}
